import gql from 'graphql-tag';

export default gql`
  mutation syncGroupRoleForExistingUsers($syncGroupRole: SyncGroupRoleInput!) {
    syncGroupRoleForExistingUsers(syncGroupRole: $syncGroupRole)
  }
`;
